import { lazy } from 'react';
import { Routes, SyncHook } from '../routeTypes';

// Lazy load the TrainingAdminPage component
const TrainingAdminPage = lazy(() =>
  import('react-components/admin/TrainingAdminPage').then(module => ({
    default: module.default,
  }))
);

const useSyncHook: SyncHook = null;

// const routes: Routes = [
//   { path: '/training-admin', element: <TrainingAdminPage /> },
// ];

const routes: Routes = [
  {
    path: '/training-admin',
    element: <TrainingAdminPage />,
  },
];

const useNavigationHooks = () => {
  return {};
};

export const trainingAdminPageRouteConfig = {
  routes,
  useSyncHook,
  useNavigationHooks,
};
